import { definePreset } from "@primeuix/themes";
import Lara from "@primeuix/themes/lara";

/**
 * PrimeNG 18+ dropped the CSS themes (saga-blue) in favour of design-token presets.
 * This preset maps the saga-blue values onto Lara so tables, checkboxes and inputs
 * keep the look they had on PrimeNG 17.
 */
const SagaBlue = definePreset(Lara, {
  semantic: {
    primary: {
      50: "#e3f2fd",
      100: "#bbdefb",
      200: "#90caf9",
      300: "#64b5f6",
      400: "#42a5f5",
      500: "#2196f3",
      600: "#1e88e5",
      700: "#1976d2",
      800: "#1565c0",
      900: "#0d47a1",
      950: "#0a3880",
    },
    formField: {
      paddingX: "0.5rem",
      paddingY: "0.5rem",
      borderRadius: "3px",
    },
    colorScheme: {
      light: {
        // saga-blue was built on the Bootstrap grey scale
        surface: {
          0: "#ffffff",
          50: "#f8f9fa",
          100: "#e9ecef",
          200: "#dee2e6",
          300: "#ced4da",
          400: "#adb5bd",
          500: "#6c757d",
          600: "#5a6268",
          700: "#495057",
          800: "#343a40",
          900: "#212529",
          950: "#16191c",
        },
      },
    },
  },
  components: {
    datatable: {
      root: { borderColor: "#e9ecef" },
      header: { padding: "1rem 1rem" },
      headerCell: { padding: "1rem 1rem" },
      bodyCell: { padding: "1rem 1rem" },
      columnTitle: { fontWeight: "600" },
      colorScheme: {
        light: {
          header: { background: "#f8f9fa", color: "#495057" },
          headerCell: { background: "#f8f9fa", color: "#495057" },
        },
      },
    },
    checkbox: {
      root: {
        width: "20px",
        height: "20px",
        borderRadius: "3px",
      },
    },
  },
});

export const primeNgTheme = {
  preset: SagaBlue,
  options: {
    // saga-blue was light-only; never follow the OS dark mode
    darkModeSelector: false,
  },
};
